import { create } from 'zustand';

interface BaseFilters {
  page: number;
  limit: number;
  search: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

interface FilterState<T extends BaseFilters> {
  current: T;
  set: (filters: Partial<T>) => void;
  reset: () => void;
}

export function createFilterStore<T extends BaseFilters>(defaultFilters: T) {
  return create<FilterState<T>>()((set) => ({
    current: { ...defaultFilters },
    set: (filters) =>
      set((state) => ({
        current: { ...state.current, ...filters, page: filters.page ?? 1 },
      })),
    reset: () => set({ current: { ...defaultFilters } }),
  }));
}
